module.exports = __webpack_public_path__ + "img/thumbnail_GiantOtter_j_normal.7cd58f9e.png";